import { PATH } from "router/config/const";
import i18n from "i18n";
const t = i18n.t;

export const truncConfig = {
  length: 17,
};

export const iconType = {
  msp: 'icon icon-msp',
  org: 'icon icon-org',
  tag: 'icon icon-tag',
  site: 'icon icon-site',
};

export const DEFAULT_TARGET_OBJ = {
  icon: null,
  name: 'b1c94ca2fb',
  id: null,
  type: null,
};

export const userDropdownList = () => {
  const list = [
    {
      title: t('90b1f66519'),
      icon: 'icon-user',
      link: PATH.user_profile,
    },
    {
      title: t('5a083e477f'),
      icon: 'icon-switch-portal',
    },
    // {
    //   title: 'Log in Cloud portal',
    //   icon: 'icon-switch-portal',
    // },
    {
      title: t('0323de4f66'),
      icon: 'icon icon-logout',
      logout: true,
    }
  ];
  return list;
};